export default (params) => ({
  trigger: {
    name: 'last_order_block.view_element',
    params: params,
  },
  config: {
    schema: {
      order_id: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
    },
    event: {
      name: 'view_last_order',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
